<template>
  <div>
    <div
      class="d-flex "
      :class="{
        'flex-column': $vuetify.breakpoint.smAndDown,
        'justify-space-between': !$vuetify.breakpoint.smAndDown,
        'align-center': !$vuetify.breakpoint.smAndDown,
      }"
    >
      <div
        v-for="item in legendItems"
        :key="item.label"
        class="d-flex align-center legend-item"
        :class="{ 'justify-start': $vuetify.breakpoint.smAndDown }"
        @click.stop="toggleActive(item)"
      >
        <div
          class="legend-color-box"
          :style="{ backgroundColor: item.color }"
        ></div>
        <div class="legend-label" :class="{ inactive: !item.active }">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    layout: {
      type: String,
      default: "vertical",
      validator: (value) => ["vertical", "horizontal"].includes(value),
    },
  },
  data() {
    return {
      legendItems: [
        {
          type: "teacher-availability",
          label: "Teacher Availability",
          color: "#D3D3D3",
          active: true,
        },
        {
          type: "schedule",
          label: "Teacher Schedule",
          color: "#24abf2",
          active: true,
        },
        {
          type: "student-schedule",
          label: "Student Schedule",
          color: "#f2a024",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.updateActiveStates();
  },
  watch: {
    value: {
      handler() {
        this.updateActiveStates();
      },
      deep: true,
    },
  },
  methods: {
    updateActiveStates() {
      this.legendItems.forEach((item) => {
        item.active = this.value.includes(item.type);
      });
    },
    toggleActive(item) {
      item.active = !item.active;
      this.$emit("stateChange", this.legendItems);
    },
  },
};
</script>

<style scoped>
.legend-item {
  flex: 1 0 auto;
  margin: 10px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.93); /* Transparent white background */
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

/* Mobile-specific styles */
@media (max-width: 600px) {
  .legend-item {
    width: 200px; /* Full-width on small screens */
    margin: 5px 0; /* Reduce margin to fit better */
    margin-left: 80px;
  }
}

.legend-color-box {
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-radius: 50%;
  display: inline-block;
}

.inactive {
  opacity: 0.5; /* Reduced opacity for a disabled effect */
  color: #a0a0a0; /* Gray color for a disabled effect */
}
</style>
